// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FullscreenContent_wrapper___PuRq","controlBar":"FullscreenContent_controlBar__zxZdl","iconButton":"FullscreenContent_iconButton__tBUU1"};